import request from '@/utils/httpRequest'

export default class MarchOutService {
    queryById (id) {
        return request({
            url: '/shye/contract/shyeMarchOut/queryById',
            method: 'get',
            params: {id: id}
        })
    }

    feeDetailsByContractId (projectId,bizType,contractId) {
        return request({
            url: '/finance/wuyeFinanceMeterReadingDetail/feeDetailsByContractId',
            method: 'get',
            params: {projectId,bizType,contractId}
        })
    }
    getReceivables (contractId,leasedeadline) {
        return request({
            url: '/shye/contract/shyeMarchOut/getReceivables',
            method: 'get',
            params: {contractId: contractId,leasedeadline:leasedeadline}
        })
    }

    startFlow (params) {
        return request({
            url: '/shye/contract/shyeMarchOut/startFlow',
            method: 'post',
            data: params
        })
    }
}
